/**
 * 홈페이지 번역 - 한국어
 */

export default {
  hero: {
    title: '지능형 인프라 · 아시아태평양 연결',
    subtitle: 'Global Data는 선도적인 기술 솔루션으로 기업의 디지털 전환을 지원하며, 더 지능적이고 연결된 미래를 구축합니다',
    cta: '지금 문의하기',
    learnMore: '더 알아보기'
  },

  coreMetrics: {
    title: '핵심 지표 대시보드',
    subtitle: '숫자가 말하고 역량이 증명합니다',
    systemAvailability: '시스템 가용성',
    serviceRegions: '서비스 지역',
    clientsServed: '고객사 수',
    certifications: '인증 수',
    highAvailability: '연중 고가용성 보장',
    coveringAsiaPacific: '아시아태평양 주요 시장 커버',
    enterpriseClients: '누적 엔터프라이즈 고객 수',
    internationalCerts: '국제 공인 인증 보유'
  },

  serviceRegions: {
    title: '서비스 커버리지 맵',
    subtitle: 'APAC 11개 서비스 지역을 커버하며, 지도 노드를 클릭하면 현지 서비스 상세를 확인할 수 있습니다.',
    viewAllRegions: '전체 지역 보기'
  },

  certifications: {
    title: '자격 및 컴플라이언스 역량',
    subtitle: '국제 표준 인증과 다지역 컴플라이언스 보장',
    viewAll: '모든 인증 보기',
    validUntil: '유효 기간',
    issuedBy: '발급 기관',
    categories: {
      quality: '품질 관리',
      security: '보안',
      telecom: '통신',
      technology: '기술 파트너',
      privacy: '개인정보 및 컴플라이언스'
    }
  },

  caseStudies: {
    title: '최신 성공 사례',
    subtitle: '실제 프로젝트로 검증된 역량',
    filterByIndustry: '산업별 필터',
    allIndustries: '전체 산업',
    finance: '금융',
    healthcare: '헬스케어',
    manufacturing: '제조',
    government: '정부',
    retail: '리테일',
    professional: '전문 서비스',
    education: '교육',
    viewAllCases: '모든 사례 보기',
    viewDetail: '상세 보기',
    outcome: '프로젝트 성과',
    industry: '산업',
    region: '지역',
    noResults: '아직 {industry} 관련 사례가 없습니다. 다른 산업을 확인해 주세요.',
    noCases: '표시할 사례가 없습니다.'
  },

  testimonials: {
    title: '고객 후기',
    subtitle: '고객이 직접 전하는 평가',
    rating: '평점'
  },

  regionalContact: {
    title: '문의하기',
    subtitle: '11개 서비스 지역에서 언제나 지원합니다',
    office: '서비스 센터',
    phone: '전화',
    email: '이메일',
    businessHours: '운영 시간',
    viewContactPage: '전체 연락처 정보 보기'
  },

  cta: {
    title: '지금 당사 제품을 경험해 보세요',
    subtitle: 'Global Data는 최첨단 기술 솔루션을 제공합니다. 당사의 제품은 수백 개 기업의 디지털 전환과 운영 효율 향상, 비즈니스 성장에 기여해 왔습니다.',
    contact: '문의하기',
    trialNow: '무료 체험 시작'
  },

  news: {
    latest: '최신 소식',
    industry: '산업 인사이트',
    company: '회사 소식',
    item1: {
      content: 'Global Data가 글로벌 선도 AI 기업과 협력하여 AI의 새로운 가능성을 모색합니다.',
      date: '2023년 10월 26일'
    },
    item2: {
      content: 'Global Data가 2024 기술 트렌드 리포트를 발표하며 클라우드와 빅데이터에 주목했습니다.',
      date: '2023년 10월 20일'
    },
    item3: {
      content: 'Global Data가 “올해의 기술 혁신 기업상”을 수상했습니다.',
      date: '2023년 10월 15일'
    }
  },

  insights: {
    title: '주목할 만한 트렌드와 인사이트',
    digitalTransformation: {
      title: '디지털 전환: 비즈니스 성장의 새로운 엔진',
      description: '디지털 전환이 비즈니스 환경을 어떻게 재편하고 있는지, 그리고 Global Data가 기업의 효율적 전환을 어떻게 지원하는지 살펴봅니다.'
    },
    aiFuture: {
      title: 'AI와 미래: 지능 시대의 무한한 가능성',
      description: '인공지능의 최신 발전과 산업별 적용 가능성을 살펴보고 Global Data의 AI 솔루션 방향을 소개합니다.'
    },
    bigData: {
      title: '빅데이터: 비즈니스 인사이트의 원천',
      description: '빅데이터가 어떻게 의사결정을 지원하는지, 그리고 Global Data가 제공하는 종합 데이터 분석 역량을 소개합니다.'
    }
  },

  coreServices: {
    kicker: 'Service Portfolio',
    title: '핵심 서비스',
    subtitle: '통합 SLA, 지역 간 조정, 현지 실행을 균형 있게 제공하며 디지털 전 주기에 걸친 안정적인 인프라와 운영 역량을 제공합니다.',
    viewDetail: '자세히 보기',
    viewAllServices: '서비스 전체 보기',
    items: [
      {
        sectionId: 'digital-workplace',
        eyebrow: '디지털 워크플레이스',
        title: '데스크톱·엔드포인트 경험',
        description: '단말, 계정·권한, 협업 도구를 통합 지원합니다. 입퇴사, 원격 근무, IT 자산 라이프사이클 관리까지 포함해 생산성과 근무 경험을 높입니다.'
      },
      {
        sectionId: 'data-center-network',
        eyebrow: '네트워크·데이터센터',
        title: '기업·매장 네트워크',
        description: 'LAN/WAN/WiFi, 스위치·방화벽 구축·유지보수와 데이터센터·기실 운영까지 담당하여 미션 크리티컬 업무의 연속성을 보장합니다.'
      },
      {
        sectionId: 'cloud-operations',
        eyebrow: '클라우드·클라우드 운영',
        title: '클라우드 아키텍처·비용 최적화',
        description: '퍼블릭·하이브리드 클라우드 설계·이전, 운영·보안 모니터링, 비용 최적화로 확장성과 비즈니스 변화 대응력을 강화합니다.'
      },
      {
        sectionId: 'retail-store-ops',
        eyebrow: '매장 IT 운영',
        title: '다매장 표준화 전달',
        description: '다국가·다매장 표준 운영, POS·매장 네트워크, 신규 오픈·이전·업그레이드를 지원하여 영업 중단 리스크를 줄입니다.'
      }
    ]
  },

  productExtensions: {
    title: '디지털 역량',
    subtitle: '스마트 티켓 및 AI 분석 플랫폼 외에 CRM 개발, 마케팅 자동화, 미니 프로그램, AI 지식 베이스, 오피스 지능형 에이전트로 데이터 기반 운영을 확장합니다.',
    viewAll: '제품 역량 보기',
    items: [
      {
        title: 'CRM 소프트웨어 개발',
        tagline: '멤버십 체계와 C-엔드 사용자 운영',
        description: '회원 프로필, 세분화, 포인트, 혜택, 참여 유도, 재구매 운영을 지원하는 소비자 대상 멤버십 CRM을 구축합니다.'
      },
      {
        title: 'MA 마케팅 자동화',
        tagline: '자동화된 참여와 전환 성장',
        description: '웹사이트, CRM, 이메일, 메시징 채널을 연결해 폐쇄형 리드 육성 여정을 구축합니다.'
      },
      {
        title: '미니 프로그램 개발',
        tagline: '가벼운 서비스 진입 채널',
        description: '예약, 수리 요청, 문의, 멤버십 서비스를 위한 맞춤형 미니 프로그램을 제공합니다.'
      },
      {
        title: 'AI 지식 베이스',
        tagline: '지식 축적과 질의응답',
        description: 'FAQ, SOP, 티켓 처리 경험, 제품 자료를 의미 검색과 권한 제어 기반으로 통합합니다.'
      },
      {
        title: '오피스 지능형 에이전트',
        tagline: '사무 흐름 자동화',
        description: '이메일, 승인, 회의록, 업무 흐름, 지식 조회를 연결해 내부 협업 효율을 높입니다.'
      }
    ]
  },

  mission: {
    title: '우리의 미션',
    description: 'Global Data는 세계적인 기술 서비스 기업이 되는 것을 목표로 합니다. 지속적인 혁신과 탁월한 서비스로 고객의 비즈니스 성장과 디지털 전환을 지원하며 더 지능적이고 연결된 미래를 함께 만들어 갑니다. 우리는 기술의 힘을 믿으며 사회적 가치를 창출하는 원동력으로 활용합니다.'
  },

  expertise: {
    title: '전문 역량',
    bigData: {
      title: '빅데이터 및 분석',
      description: '데이터 수집부터 심층 분석까지, 대규모 데이터에서 가치 있는 인사이트를 발굴해 지능형 의사결정을 지원합니다.'
    },
    ai: {
      title: '인공지능 및 머신러닝',
      description: '자연어 처리, 컴퓨터 비전, 지능형 자동화를 포함한 맞춤형 AI 솔루션을 설계하고 구축합니다.'
    },
    itConsulting: {
      title: 'IT 컨설팅 및 운영 관리',
      description: '전략적 IT 컨설팅, 프로젝트 관리, IT 운영 최적화를 통해 기술 투자가 비즈니스 목표와 정렬되도록 지원합니다.'
    }
  },

  services: {
    title: '주요 서비스',
    ticketSystem: {
      title: '스마트 티켓 시스템',
      subtitle: '서비스 요청과 이슈를 효율적으로 관리하세요',
      description: '당사의 스마트 티켓 시스템은 요청 접수부터 해결까지 전 과정을 시각화하여 서비스 요청 프로세스를 간소화합니다. 티켓 상태를 실시간으로 추적하고 처리 진행 상황을 파악하며 기술팀과 원활하게 소통할 수 있습니다.',
      features: {
        realTimeTracking: '실시간 상태 추적',
        multiChannel: '멀티채널 접수',
        smartAssignment: '지능형 배정',
        historyQuery: '이력 조회'
      },
      progressTitle: '티켓 처리 진행 예시'
    },
    aiSolutions: {
      title: 'AI 기반 솔루션',
      subtitle: '인공지능으로 비즈니스 성장을 가속화하세요',
      description: '최신 인공지능 기술을 비즈니스 프로세스에 통합하여 지능형 고객 서비스, 데이터 예측, 자동화 의사결정 등 맞춤형 AI 솔루션을 제공합니다. 이를 통해 운영 효율과 사용자 경험을 동시에 향상시킵니다.',
      features: {
        chatbot: '지능형 챗봇',
        biAnalytics: '비즈니스 인텔리전스 분석',
        recommendation: '개인화 추천',
        security: '지능형 보안 보호'
      },
      ctaButton: 'AI 솔루션 살펴보기'
    }
  }
}
